import React from "react";
import { Table } from "react-bootstrap";
import IntegerFmt from "../../../../common/typeFormatting/IntegerFmt";
import Dollars from "../../../../common/typeFormatting/Dollars";

export default function PlanHeader({planSummary}) {

    return (
        <Table style={{width: 600, fontSize: 12,border: 1,padding: 2}}>
            <thead>
                <tr>
                    <th className="text-center" style={{width: 150}}>Total Options</th>
                    <th className="text-center" style={{width: 150, backgroundColor: "rgb(243,243,243,1)"}}>Vested Options</th>
                    <th className="text-center" style={{width: 150, backgroundColor: "rgb(243,243,243,1)"}}>Vested Options w/ Positive Value</th>
                    <th className="text-center" style={{width: 150}}>Current Price</th>                  
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-center font-weight-bold" style={{fontSize: 18}}><IntegerFmt>{planSummary.totalOptions}</IntegerFmt></td>
                    <td className="text-center font-weight-bold" style={{fontSize: 18, backgroundColor: "rgb(243,243,243,1)"}}><IntegerFmt>{planSummary.vestedOptions}</IntegerFmt></td>
                    <td className="text-center font-weight-bold" style={{fontSize: 18, backgroundColor: "rgb(243,243,243,1)"}}><Dollars>{planSummary.vestedWithPositiveValue}</Dollars></td>
                    <td className="text-center font-weight-bold" style={{fontSize: 18}}><Dollars>{planSummary.currentPrice}</Dollars></td>                    
                </tr>
            </tbody>
        </Table>
    );
}